module.exports = __webpack_public_path__ + "static/media/mostMoney_48.81661ee0.png";